/**
 * The icon a chat list row shows next to its message preview, derived from
 * what the newest message carries — TA-10878.
 *
 * Mirrors the server's own rule, and the one ChatsSearch.web.tsx applies to
 * search results: gate on Documents (PublicTeam and the message
 * task/project attachments joined the Attachment union and are not files),
 * photo attachments get the gallery icon, anything else a paperclip.
 *
 * Returns null for a message with no documents — a plain text message. That
 * null is meaningful: written onto the Chat it clears the icon the previous
 * attachment message left behind, which otherwise stays on the row forever.
 */
export type MessageIconAttachment = {
  __typename?: string | null;
  isImage?: boolean | null;
};

export type ChatRowMessageIcon = 'Gallery' | 'Paperclip' | null;

export const messageIconForAttachments = (
  attachments?: readonly (MessageIconAttachment | null | undefined)[] | null
): ChatRowMessageIcon => {
  const documents = (attachments ?? []).filter(
    (attachment) => attachment?.__typename === 'Document'
  );
  if (documents.length === 0) return null;
  return documents.some((document) => document?.isImage)
    ? 'Gallery'
    : 'Paperclip';
};
